module.exports = __webpack_public_path__ + "static/logo-4597eceae4df1cdfcedead72ac574ffa.svg";